// src/typography.ts
var typography = {
  fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  sizes: { xs: 11, sm: 14, base: 16, lg: 22, xl: 28, "2xl": 32, "3xl": 36, "4xl": 57 },
  weights: { normal: 400, medium: 500, semibold: 600, bold: 700 },
  lineHeights: { tight: 1.25, normal: 1.5, relaxed: 1.75 }
};

export {
  typography
};
